import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Button from '../../core/Buttons';

import { StyledModal, StyledInput, StyledDniInfo } from './style';

const ModalPassword = ({
  clickCloseIcon,
  action,
  labelTitle,
  labelButton,
  errorDni
}) => {
  const [dni, setDni] = useState('');
  const [isDniCorrect, setIsDniCorrect] = useState(!errorDni);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  useEffect(() => {
    setIsDniCorrect(!errorDni);
  }, []);

  return (
    <StyledModal
      title={labelTitle || 'CONFIRMA TU CONTRASEÑA'}
      clickCloseIcon={clickCloseIcon}
    >
      <p> Introduce DNI</p>
      <StyledInput
        autoComplete="dni"
        type="text"
        placeholder="DNI"
        error={!isDniCorrect && `El DNI es incorrecto`}
        onChange={value => {
          setDni(value);
          setIsButtonDisabled(!value);
        }}
      />
      <StyledDniInfo>
        IMPORTANTE: La contraseña para abrir el pdf descargado será el DNI del
        trabajador sin ceros por la izquierda y con la letra mayúscula.
      </StyledDniInfo>
      <Button
        secondary
        disabled={isButtonDisabled}
        onClick={() => {
          action(dni);
        }}
      >
        {labelButton || 'DESCARGAR'}
      </Button>
    </StyledModal>
  );
};

ModalPassword.propTypes = {
  action: PropTypes.func,
  clickCloseIcon: PropTypes.func
};

export default ModalPassword;
